import { useMemo, useState } from "react";
import { Button } from "../../../components/Button";
import { ReactComponent as AlertIcon } from "../../../assets/icons/Alert.svg";

import { AutismChallenge, ClientQuizFormType } from "./ClientQuiz";
import { MultiSelect } from "../../../components/MultiSelect";

export function Step3({
  onNext,
  clientQuizForm: form,
  setClientQuizForm: setForm
}: {
  onNext: () => void;
  clientQuizForm: ClientQuizFormType;
  setClientQuizForm: (value: ClientQuizFormType) => void;
}) {
  const [errors, setErrors] = useState({} as any);
  const [error, setError] = useState<string>("");
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;



    setForm({ ...form, [name]: value } as ClientQuizFormType);
  };

  const validateAndNext = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return
    }

    onNext();
  };

  const disabled = useMemo(() => {
    return !form.challenges || form.challenges.length === 0
  }, [form]);

  return (
    <>
      <div className="bg-white p-8 rounded-[16px]">
        <form className="mt-4 flex flex-col gap-[22px]" onSubmit={validateAndNext}>
          <div className="flex flex-col md:flex-row items-center gap-3">
            <div className="flex-1 w-full flex flex-col gap-1.5">
            <div className="text-primary font-bold">3.</div>
              <label className="text-lg text-black/80">
                What challenges are you seeking support with?
              </label>
                  <MultiSelect
                  options={Object.values(AutismChallenge).map((value) => ({
                    value,
                    label: value.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
                  }))}
                  value={form.challenges || []}
                  name="challenges"
                  onChange={(selectedOptions) => {
                  setForm({
                    ...form,
                    challenges: selectedOptions.map((o) => o.value),
                  } as ClientQuizFormType);
                }}
              />
            </div>
            <div />
          </div>

          <div className="mt-7">
            {error && (
              <div className="text-red-500 text-xs font-medium mb-4 flex items-center gap-1">
                <AlertIcon /> {error}
              </div>
            )}
            <Button
              type="submit"
              variant="primary"
              className="!rounded-full w-full"
              disabled={disabled || saving}
              loading={saving}
              onClick={validateAndNext}
            >
              Next
            </Button>
          </div>
        </form>
      </div>

    </>
  );
}
